





























































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import api from "@/api";
import {imageUrl} from '@/utils/common'
import {base64DownloadFile, ExportExcel} from "@/utils/exportFile";
import store from "@/store";
@Component({})
export default class invoicerList extends Vue {
  detail: any = {};
  detailDialog = false;
  // 表格数据
  tableData = [];
  // 加载状态
  loading = false;
  // 总条数
  total = 0;
  // 搜索条件
  search: any = {
    invoiceStatus: "",
    invoiceType: "",
    applyTimes: [],
    invoiceTime: [],
    pagination: {
      page: 0, //页码，从0开始
      pageSize: 20, //每页数量
    },
  };

  toOrder(row: any) {
    this.$router.push({
      path: "/shop/listDetail",
      query: {
        id: row.orderId,
      },
    });
  }

  toDown(row: any) {
    api.post("J27740", { id: row.id }).then((res) => {
        base64DownloadFile(res.fileName, res.fileBase64 )
    });
  }

  kaipiaoDialog = false;

  baseUrl = imageUrl;

  dataAuth = {};
  fileList: any = {}
  handleAvatarSuccess(res: any, file: any) {
    console.log("file", file, res);
    if (res.errcode == 0) {
      let obj = {
        image_name: file.name,
        image_url: res.data
      }
      this.fileList = obj
    } else {
      this.$message.error("上传失败");
    }
  }

  beforeAvatarUpload(file: any) {
    const isJPG = file.type === "application/pdf";
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isJPG) {
      this.$message.error("限制上传pdf格式!");
    }
    // if (!isLt2M) {
    //   this.$message.error("上传图片大小不能超过 2MB!");
    // }
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    let _that = this;
    return new Promise(function (resolve, reject) {
      if (isJPG) {
        _that.loading = true
        api
          .post("J27501", {
            fileName: file.name,
            softLink: "",
          })
          .then((data) => {
            _that.dataAuth = data;
            resolve(true);
          })
          .catch(() => {
            reject(false);
          }).finally(() => {
            _that.loading = false
          });
      } else {
        reject(false);
      }
    });
  }

  toKaiPiao(row: any) {
    this.fileList = {}
    this.detail = row;
    this.kaipiaoDialog = true;
  }
  handleCloseKaipiao() {
    this.kaipiaoDialog = false;
  }
  sure() {
    if(!this.fileList.image_url) {
      this.$message.warning('请上传文件')
      return
    }
    this.loading = true
    api.post('J27741', {
      id: this.detail.id,
      invoiceFileUrl: this.fileList.image_url
    }).then(res => {
      this.$message.success('操作成功')
      this.kaipiaoDialog = false
      this.searchTable()
    }).finally(() => {
      this.loading = false
    })
  }

  toCancle(row: any) {
    const h = this.$createElement;
    this.$msgbox({
      title: "操作提示",
      message: h("div", {}, [
        h("p", {}, "是否确认取消发票申请？"),
        h("p", { style: "font-size: 14px" }, "如需开票，需重新申请"),
      ]),
      showCancelButton: true,
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      beforeClose: (action, instance, done) => {
        if (action == "confirm") {
          api
            .post("J27738", { id: row.id })
            .then((res) => {
              this.$message.success("操作成功");
              this.searchTable()
              done();
            });
        } else {
          done();
        }
      },
    });
  }

  logDialog = false;
  logList = [];
  logTotal = 0;
  listLoading = false;
  log = {
    bus_id: "",
    module_code: "goodsOrdManager",
    // goodsOrdManager: '',
    pagination: {
      page: 0, //页码，从0开始
      pageSize: 20, //每页数量
    },
  };
  lookLogDialog = false;

  // 日志
  cancleLog() {
    this.logDialog = false;
  }
  cancleLogLook() {
    this.lookLogDialog = false;
  }

  logSearch = {
    objectId: "",
    objectType: "invoice_manage",
    pagination: {
      page: 0, //页码，从0开始
      pageSize: 10, //每页数量
    },
  };
  logTable = [];
  toLog(row: any) {
    this.logSearch.objectId = row.id
    api.post("J27743", { ...this.logSearch }).then((res) => {
      this.logDialog = true;
      this.logTable = res.list;
      this.logTotal = res.total;
    });
  }

  changeLog(page: any) {
    this.logSearch.pagination.page = page - 1;
    api.post("J27756", { ...this.logSearch }).then((res) => {
      // this.logDialog = true
      this.logTable = res.list;
      this.logTotal = res.total;
    });
  }

  row = {};
  logDetail = false;
  openDesc = false;
  handleCloseLogDialog() {
    this.logDialog = false;
  }
  toLogDetail(row: any) {
    this.logDetail = true;
    this.row = row;
  }
  CloseLogDetailDialog() {
    this.logDetail = false;
  }

  //获取交易中心
  channelList: any = {};

  handleCloseDetail() {
    this.detailDialog = false;
  }

  // 搜索 search:true 重置翻页
  searchTable(search = false) {
    this.loading = true;
    if (search) {
      this.search.pagination = {
        pageSize: 20,
        page: 0,
      };
    }
    api
      .post("J27742", {
        ...this.search,
      })
      .then((data) => {
        this.total = data.total;
        this.tableData = data.list;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  toDetail(row: any) {
    api.post("J27739", { id: row.id }).then((res) => {
      this.detail = res;
      this.detailDialog = true;
    });
  }

  config = {}
  getConfig() {
    api.getJavaConfig().then((res) => {
      this.config = res;
    });
  }

  activated() {
    this.getConfig()
    this.searchTable();
  }
}
